import { subscribe, getState, setIdentity, setGuestIdentity, clearIdentity, setViewMode, addPlayerLocal } from '../state/store.js';
import { createPlayer, updatePlayer } from '../services/supabase.js';

const identityModal = document.getElementById('identityModal');
const identityPlayerSelect = document.getElementById('identityPlayerSelect');
const identityNewName = document.getElementById('identityNewName');
const identityNewDiscord = document.getElementById('identityNewDiscord');
const identityJoinBtn = document.getElementById('identityJoinBtn');
const identityGuestBtn = document.getElementById('identityGuestBtn');
const identityChip = document.getElementById('identityChip');
const identityChipInitials = document.getElementById('identityChipInitials');
const notYouLink = document.getElementById('notYouLink');
const accountModal = document.getElementById('accountModal');
const accountForm = document.getElementById('accountForm');
const accountModalName = document.getElementById('accountModalName');
const accountDiscordField = document.getElementById('accountDiscordField');
const discordIdInput = document.getElementById('discordIdInput');
const accountCancelBtn = document.getElementById('accountCancelBtn');
const viewModePlayerInput = document.getElementById('viewModePlayer');
const viewModeDmInput = document.getElementById('viewModeDm');

const escapeHTML = (value = '') =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

const escapeAttr = (value = '') =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;');

const getInitials = (name = '') => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return '?';
};

const renderIdentityPlayers = (players = []) => {
  if (!identityPlayerSelect) return;
  const sorted = players
    .slice()
    .sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }));
  const placeholder = players.length ? 'Select your name…' : 'No players yet — join below';
  const options = sorted
    .map(
      (player) =>
        `<option value="${escapeAttr(player.id)}" data-name="${escapeAttr(player.name)}">${escapeHTML(player.name)}</option>`
    )
    .join('');
  identityPlayerSelect.innerHTML = `<option value="">${placeholder}</option>${options}`;
  identityPlayerSelect.disabled = !players.length;
};

export const openIdentityModal = () => {
  if (!identityModal) return;
  renderIdentityPlayers(getState().players);
  if (!identityModal.open) identityModal.showModal();
};

export const maybeShowIdentityModal = () => {
  if (!getState().identity) openIdentityModal();
};

const handlePickPlayer = () => {
  const option = identityPlayerSelect?.selectedOptions[0];
  if (!option || !option.value) return;
  setIdentity({ playerId: option.value, name: option.dataset.name });
  identityPlayerSelect.value = '';
  identityModal?.close();
};

const handleJoin = async () => {
  const name = identityNewName?.value.trim() || '';
  if (!name) {
    alert('Please enter your name.');
    return;
  }
  try {
    const created = await createPlayer({ name, discord_id: identityNewDiscord?.value || '' });
    addPlayerLocal(created);
    setIdentity({ playerId: created.id, name: created.name });
    identityModal?.close();
  } catch (error) {
    alert(`Failed to join: ${error.message}`);
  }
};

const handleGuest = () => {
  setGuestIdentity();
  identityModal?.close();
};

const openAccountModal = () => {
  const state = getState();
  if (!state.identity) return;
  const isGuest = state.identity.isGuest;
  if (accountModalName) accountModalName.textContent = state.identity.name;
  if (accountDiscordField) accountDiscordField.hidden = isGuest;
  if (!isGuest && discordIdInput) {
    const player = state.players.find((p) => String(p.id) === String(state.identity.playerId));
    discordIdInput.value = player?.discord_id || '';
  }
  if (accountModal && !accountModal.open) accountModal.showModal();
};

const handleAccountSubmit = async (event) => {
  event.preventDefault();
  const state = getState();
  if (!state.identity?.playerId) {
    accountModal?.close();
    return;
  }
  try {
    const updated = await updatePlayer(state.identity.playerId, { discord_id: discordIdInput?.value || '' });
    addPlayerLocal(updated);
    accountModal?.close();
  } catch (error) {
    alert(`Failed to update Discord ID: ${error.message}`);
  }
};

const handleNotYou = () => {
  accountModal?.close();
  clearIdentity();
  openIdentityModal();
};

const renderIdentityState = (state) => {
  const hasIdentity = !!state.identity;
  if (identityChip) identityChip.hidden = !hasIdentity;
  if (identityChipInitials) identityChipInitials.textContent = hasIdentity ? getInitials(state.identity.name) : '';
  if (notYouLink) notYouLink.hidden = !hasIdentity;
  if (viewModePlayerInput) viewModePlayerInput.checked = state.viewMode !== 'dm';
  if (viewModeDmInput) viewModeDmInput.checked = state.viewMode === 'dm';
  document.body.classList.toggle('dm-view', state.viewMode === 'dm');
  document.body.classList.toggle('guest-view', state.viewMode === 'guest');
};

export const initIdentity = () => {
  identityPlayerSelect?.addEventListener('change', handlePickPlayer);
  identityJoinBtn?.addEventListener('click', handleJoin);
  identityGuestBtn?.addEventListener('click', handleGuest);
  notYouLink?.addEventListener('click', handleNotYou);
  identityChip?.addEventListener('click', openAccountModal);
  accountForm?.addEventListener('submit', handleAccountSubmit);
  accountCancelBtn?.addEventListener('click', () => accountModal?.close());
  viewModePlayerInput?.addEventListener('change', () => setViewMode('player'));
  viewModeDmInput?.addEventListener('change', () => setViewMode('dm'));

  identityModal?.addEventListener('cancel', (event) => {
    if (!getState().identity) event.preventDefault();
  });

  subscribe(renderIdentityState);
  renderIdentityState(getState());
};
